import { styled } from '@mui/material/styles';
import { Dialog } from '@mui/material';
import { COLOR } from '@src/styles/color';

const StyledDialog = styled(Dialog)`
  min-width: ${(props) => props.width || 'auto'};
  border-radius: 16px;

  .title {
    padding: 16px 24px;
    border-bottom: 1px solid ${COLOR.label[16]};
  }

  .header {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .icon {
    width: 24px;
    height: 24px;
  }

  .title-text {
    font-size: 20px;
    font-weight: 700;
  }

  .dialog-content {
    padding: 12px 24px;
  }

  .close-button {
    font-size: 14px;
    font-weight: 700;
    border-radius: 24px;
    padding: 8px 24px;
    margin-bottom: 12px;
    margin-right: 16px;
  }

  .description {
    margin-top: 12px;
  }
`;
export { StyledDialog };
